/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useReducer, useState } from "react";
import cx from "classnames";
// import { CSSTransition } from "react-transition-group";
// import "../../../Transition/fade.css";
import Spinner from "../../Loader/Spinner";
import ReactSVG from "react-svg";
import { useToggle } from "resap";

import {
  getSectionNameById,
  getSectionIdByName,
  mapAvailableSections,
  mapSectoionStyles,
  mapAllTdcTo3dd,
  mapTdcTo3dd,
  getSectionInfoById,
  findTdcBy3dd,
  getSeatIdByRowNum,
  getSeatRowNumById,
  getSectionObjById,
} from "./map3DHelper";

import classes from "./Map3D.module.scss";

import StartOver from "../../../assets/images/startOver.svg";
import ArrowLeft from "../../../assets/images/arrowLeft.svg";
import Axios from "axios";
import { API_URL } from "../../../config";

const VENUE_ID = "nam-us-10185-nationals";
const HOME_PATH = ["areamap_full"];

const mapInitState = {
  viewerInstance: null,
  viewer3dInstance: null,
  routePath: HOME_PATH,
  mainSections: null,
  isolatedSeat: null,
  sectionAvailableSeats: null,
  selectedSeats: [],
  hoveredSeat: { row: "--", seat: "--" },
  hoveredSection: null,
  seatDropdown: false,
  loading: false,
  noSeatsAvailable: false,
  maxSeatsSelected: false,
};

const mapReducer = (state, action) => {
  switch (action.type) {
    case "SET_VIEWER_INSTANCES":
      return {
        ...state,
        viewerInstance: action.viewerInstance,
        viewer3dInstance: action.viewer3dInstance,
      };

    case "ADD_ROUTE_PATH":
      return { ...state, routePath: [...state.routePath, action.section] };

    case "RESET_ROUTE_PATH":
      return { ...state, routePath: HOME_PATH };

    case "LOADING":
      return { ...state, loading: action.loading };

    case "NO_SEATS_AVAILABLE":
      return { ...state, noSeatsAvailable: action.notAvailable };

    case "MAX_SEATS_SELECTED":
      return { ...state, maxSeatsSelected: action.maxSeatsReached };

    case "REMOVE_ROUTE_PATH":
      const _routePath = state.routePath;
      _routePath.pop();
      return {
        ...state,
        routePath: _routePath,
      };
    case "SET_MAIN_SECTIONS":
      return { ...state, mainSections: action.mainSections };

    case "SET_HOVERED_SEAT":
      return { ...state, hoveredSeat: action.seatInfo };

    case "RESET_HOVERED_SEAT":
      return { ...state, hoveredSeat: { row: "--", seat: "--" } };

    case "SET_HOVERED_SECTION":
      return { ...state, hoveredSection: action.sectionName };

    case "RESET_HOVERED_SECTION":
      return { ...state, hoveredSection: null };

    case "SET_ISOLATED_SEAT":
      return { ...state, isolatedSeat: action.exist };

    case "SET_SECTION_AVAILABLE_SEATS":
      return { ...state, sectionAvailableSeats: action.seats };

    case "ADD_SELECTED_SEATS":
      return {
        ...state,
        selectedSeats: [...state.selectedSeats, action.seat],
      };
    case "REMOVE_SELECTED_SEATS":
      const updatedSeats = state.selectedSeats.filter(function (seat) {
        return seat?.id !== action.seat?.id;
      });
      return {
        ...state,
        selectedSeats: updatedSeats,
      };

    case "RESET_SELECTED_SEATS":
      return { ...state, selectedSeats: [] };
    default:
      return state;
  }
};

function Map3D(props) {
  const {
    seatsInfo,
    formStyle,
    loaderShow,
    parentClasses,
    seatInfoSelectedKey,
    flexMultiply,
    planTitle,
    planName,
    uuid,
    updateSelectedChoices,
    toggleSubmit,
    adaLink,
    switchPlanMsg,
    history,
  } = props;
  const mapContainerRef = useRef(null);
  const zoomInRef = useRef(null);
  const zoomOutRef = useRef(null);
  const viewer3dContainerRef = useRef(null);
  const [mapState, dispatch] = useReducer(mapReducer, mapInitState);
  const [openSection, setOpenSection] = useState(false);

  const { current: openSectionProps } = useRef({
    left: 0,
    duration: 0.5,
    ease: "power4.inOut",
  });
  const refOpenSection = useToggle(!openSection, openSectionProps);
  const cachedMapState = useRef(0);
  const routePath = mapState.routePath;
  const lastPage = routePath[routePath.length - 1];

  const goBackHandler = () => {
    if (routePath.length <= 1) {
      return;
    }
    dispatch({ type: "REMOVE_ROUTE_PATH" });
  };
  const goHomeHandler = () => {
    if (routePath.length <= 1) {
      return;
    }
    dispatch({ type: "RESET_SELECTED_SEATS" });
    dispatch({ type: "RESET_ROUTE_PATH" });
  };
  const checkIsolated = (obj) => {
    const viewer = obj.instance;
    var isolated = viewer.checkIsolatedNodes();
    dispatch({ type: "SET_ISOLATED_SEAT", exist: isolated?.length > 0 });
  };
  const mapClickHandler = (obj) => {
    var node = obj.nodes[0];

    if (node?.type === "section") {
      const routePath = cachedMapState.current.routePath;
      const lastPage = routePath[routePath.length - 1];
      if (node?.id === lastPage || node?.state === "unavailable") return;
      dispatch({
        type: "ADD_ROUTE_PATH",
        section: node?.id,
      });
    }
    if (node?.type === "seat") {
      if (node?.state === "unavailable") return;
      const tdcSeat = getSeatIdByRowNum(
        cachedMapState.current.sectionAvailableSeats,
        node
      );
      if (node.state === "selected") {
        dispatch({ type: "REMOVE_SELECTED_SEATS", seat: tdcSeat });
      } else {
        if (cachedMapState.current.selectedSeats?.length >= 6) {
          dispatch({ type: "MAX_SEATS_SELECTED", maxSeatsReached: true });
          setTimeout(() => {
            dispatch({ type: "MAX_SEATS_SELECTED", maxSeatsReached: false });
          }, 4000);
          return;
        }
        // updateSelectedChoices("selectedSeats", [tdcSeat]);
        dispatch({ type: "ADD_SELECTED_SEATS", seat: tdcSeat });
      }
    }
  };
  const mapLeaveHandler = () => {
    dispatch({
      type: "RESET_HOVERED_SECTION",
    });
  };
  const mapHoverHandler = (obj) => {
    const isFlexible = formStyle === "flexible";
    if (isFlexible && cachedMapState.current.routePath.length > 1) return;

    var node = obj.nodes[0];

    if (node?.type === "seat") {
      if (node.state === "available") {
        dispatch({
          type: "SET_HOVERED_SEAT",
          seatInfo: { row: node.row_id, seat: node?.id.split("-")[2] },
        });
        cachedMapState.current.viewer3dInstance.loadView3d({
          venue_id: VENUE_ID,
          view_id: node?.id,
        });
      }
    } else if (node?.type === "section") {
      if (node.state === "available") {
        dispatch({
          type: "SET_HOVERED_SECTION",
          sectionName: getSectionNameById(node.id),
        });
      }
    }
  };
  const listSectionClickHandler = (name) => {
    const id = getSectionIdByName(name);
    if (id === lastPage) return;
    if (routePath.length === 3) {
      dispatch({ type: "RESET_ROUTE_PATH" });
    }
    dispatch({
      type: "ADD_ROUTE_PATH",
      section: id,
    });
  };
  const listSectionHoverHandler = (name) => {
    cachedMapState.current.viewerInstance.hover(getSectionIdByName(name));
  };
  const deleteSelectedSeat = (seat) => {
    dispatch({ type: "REMOVE_SELECTED_SEATS", seat });
    cachedMapState.current.viewerInstance.unselect([getSeatRowNumById(seat)]);
  };
  const loadMapHandler = () => {
    // console.log("here", mapState.routePath[mapState.routePath.length - 1]);
    // console.log("here2", mapState.routePath.length);
    const mapId = mapState.routePath[mapState.routePath.length - 1];
    const isFlexible = formStyle === "flexible";
    // "areamap_full"
    var load_options = {
      venue_id: VENUE_ID,
      map_id: mapId,
    };

    if (isFlexible) {
      if (mapState.routePath.length < 2) {
        mapState.viewerInstance
          .loadMap(load_options)
          .then(function (obj) {
            const viewer = obj.instance;
            viewer.setStyles(mapSectoionStyles);
            if (mapState.selectedSeats.length > 0)
              dispatch({ type: "RESET_SELECTED_SEATS" });

            viewer.setAvailability(
              "section",
              mapState.mainSections.filter((x) => x?.id)
            );
          })
          .catch(function (err) {
            console.error(err);
          });
      }
      switch (mapState.routePath.length) {
        case 1:
          // reset no seat available
          dispatch({
            type: "NO_SEATS_AVAILABLE",
            notAvailable: false,
          });
          // reset isolated seat
          dispatch({ type: "SET_ISOLATED_SEAT", exist: false });
          if (formStyle !== "ballpark") {
            updateSelectedChoices("seatInfoSelected", "");
          }
          setOpenSection(false);
          mapState.viewerInstance.flags.automatic_hover = true;

          break;
        case 2:
          // reset no seat available
          dispatch({
            type: "NO_SEATS_AVAILABLE",
            notAvailable: false,
          });
          // reset isolated seat
          dispatch({ type: "SET_ISOLATED_SEAT", exist: false });
          setOpenSection(true);
          // console.log("HERE", getSectionInfoById(seatsInfo, mapId));
          setTimeout(() => {
            if (formStyle !== "ballpark") {
              updateSelectedChoices(
                "seatInfoSelected",
                getSectionInfoById(seatsInfo, mapId)
              );
            }
          }, 1000);
          const TdcSection = getSectionObjById(mapId).sectionId;
          mapState.viewer3dInstance.loadView3d({
            venue_id: VENUE_ID,
            view_id: mapTdcTo3dd(TdcSection),
          });
          cachedMapState.current.viewerInstance.setAvailability(
            "section",
            mapAllTdcTo3dd(seatsInfo, mapState.routePath[1])
          );
          mapState.viewerInstance.select(getSectionObjById(mapId).id);
          mapState.viewerInstance.flags.automatic_hover = false;

          break;
        case 3:
          mapState.viewer3dInstance.loadView3d({
            venue_id: VENUE_ID,
            view_id: mapId,
          });
          dispatch({
            type: "LOADING",
            loading: true,
          });

          Axios.post(`${API_URL}/getSeatAvailability`, {
            uuid,
            sectionId: findTdcBy3dd(mapId),
            sectionName: getSectionNameById(
              mapState.routePath[mapState.routePath.length - 2]
            ),
          })
            .then((response) => {
              const availableSeats = response?.data?.info?.availableSeats.map(
                (seat) => {
                  return `${mapId}-${seat?.row}-${seat?.seatNumber}`;
                }
              );
              dispatch({
                type: "SET_SECTION_AVAILABLE_SEATS",
                seats: response?.data?.info?.availableSeats,
              });
              dispatch({
                type: "LOADING",
                loading: false,
              });
              if (
                !response?.data?.info?.availableSeats ||
                response?.data?.info?.availableSeats.length <= 0 ||
                !availableSeats
              ) {
                dispatch({
                  type: "NO_SEATS_AVAILABLE",
                  notAvailable: true,
                });
              }

              cachedMapState.current.viewerInstance.setAvailability(
                "seat",
                availableSeats
              );
            })
            .catch((error) => {
              dispatch({
                type: "LOADING",
                loading: false,
              });
              console.log("error", error);
            });

          break;
        default:
          break;
      }
    } else {
      mapState.viewerInstance
        .loadMap(load_options)
        .then(function (obj) {
          const viewer = obj.instance;
          viewer.setStyles(mapSectoionStyles);

          if (mapState.selectedSeats.length > 0)
            dispatch({ type: "RESET_SELECTED_SEATS" });

          switch (mapState.routePath.length) {
            case 1:
              // reset no seat available
              dispatch({
                type: "NO_SEATS_AVAILABLE",
                notAvailable: false,
              });
              // reset isolated seat
              dispatch({ type: "SET_ISOLATED_SEAT", exist: false });

              viewer.setAvailability(
                "section",
                mapState.mainSections.filter((x) => x?.id)
              );
              if (formStyle !== "ballpark") {
                updateSelectedChoices("seatInfoSelected", "");
              }
              setOpenSection(false);

              break;
            case 2:
              // reset no seat available
              dispatch({
                type: "NO_SEATS_AVAILABLE",
                notAvailable: false,
              });
              // reset isolated seat
              dispatch({ type: "SET_ISOLATED_SEAT", exist: false });
              setOpenSection(true);
              if (formStyle !== "ballpark") {
                updateSelectedChoices(
                  "seatInfoSelected",
                  getSectionInfoById(seatsInfo, mapId)
                );
              }
              const TdcSection = getSectionObjById(mapId).sectionId;
              mapState.viewer3dInstance.loadView3d({
                venue_id: VENUE_ID,
                view_id: mapTdcTo3dd(TdcSection),
              });
              viewer.setAvailability(
                "section",
                mapAllTdcTo3dd(seatsInfo, mapState.routePath[1])
              );

              break;
            case 3:
              mapState.viewer3dInstance.loadView3d({
                venue_id: VENUE_ID,
                view_id: mapId,
              });
              dispatch({
                type: "LOADING",
                loading: true,
              });

              Axios.post(`${API_URL}/getSeatAvailability`, {
                uuid,
                sectionId: findTdcBy3dd(mapId),
                sectionName: getSectionNameById(
                  mapState.routePath[mapState.routePath.length - 2]
                ),
              })
                .then((response) => {
                  const availableSeats =
                    response?.data?.info?.availableSeats.map((seat) => {
                      return `${mapId}-${seat?.row}-${seat?.seatNumber}`;
                    });
                  dispatch({
                    type: "SET_SECTION_AVAILABLE_SEATS",
                    seats: response?.data?.info?.availableSeats,
                  });
                  dispatch({
                    type: "LOADING",
                    loading: false,
                  });
                  if (
                    !response?.data?.info?.availableSeats ||
                    response?.data?.info?.availableSeats.length <= 0 ||
                    !availableSeats
                  ) {
                    dispatch({
                      type: "NO_SEATS_AVAILABLE",
                      notAvailable: true,
                    });
                  }

                  viewer.setAvailability("seat", availableSeats);
                })
                .catch((error) => {
                  dispatch({
                    type: "LOADING",
                    loading: false,
                  });
                  console.log("error", error);
                });

              break;
            default:
              break;
          }
        })
        .catch(function (err) {
          console.error(err);
        });
    }
  };
  useEffect(() => {
    const mapInputOptions = {
      container: mapContainerRef.current,
      callbacks: {
        click: mapClickHandler,
        enter: mapHoverHandler,
        leave: mapLeaveHandler,
      },
    };

    const viewer3dInputOptions = {
      venue_id: VENUE_ID,
      container: viewer3dContainerRef.current,
    };

    const viewerPromise = window.DVM.loadModule("map_viewer", mapInputOptions);
    const viewer3dPromise = window.DVM.loadModule(
      "3d_viewer",
      viewer3dInputOptions
    );

    Promise.all([viewerPromise, viewer3dPromise])
      .then(function (result) {
        const _viewer = result[0];
        const _viewer3d = result[1];

        _viewer.flags.fixed_aspect_ratio = true;
        // _viewer.flags.variable_zoom_on_resize = true;
        // _viewer.flags.max_zoom_on_first_limit = true;

        // _viewer.flags.panning = !isTouch();
        _viewer.bindInterfaceAction(zoomInRef.current, "zoom-in");
        _viewer.bindInterfaceAction(zoomOutRef.current, "zoom-out");
        _viewer.max_selection = 6;
        _viewer.subscribe("select", checkIsolated);
        _viewer.subscribe("unselect", checkIsolated);

        dispatch({
          type: "SET_VIEWER_INSTANCES",
          viewerInstance: _viewer,
          viewer3dInstance: _viewer3d,
        });
      })
      .catch(function (err) {
        console.error(err);
      });
  }, []);
  useEffect(() => {
    cachedMapState.current = mapState;

    if (seatsInfo) {
      mapAvailableSections(seatsInfo).then((availability) => {
        const isSameSeats =
          JSON.stringify(mapState.mainSections) ===
          JSON.stringify(availability);

        if (!isSameSeats)
          dispatch({ type: "SET_MAIN_SECTIONS", mainSections: availability });
      });
    }
    if (
      !mapState.viewerInstance ||
      !mapState.viewer3dInstance ||
      !mapState.mainSections
    )
      return;
    loadMapHandler();
  }, [
    mapState.viewerInstance,
    mapState.viewer3dInstance,
    mapState.mainSections,
    mapState.routePath.length,
    seatsInfo,
  ]);

  useEffect(() => {
    if (props.loaderShow) {
      dispatch({ type: "RESET_ROUTE_PATH" });
    }
  }, [props.loaderShow]);

  useEffect(() => {
    cachedMapState.current = mapState;
    updateSelectedChoices(
      "selectedSeats",
      mapState.selectedSeats || mapState.selectedSeats?.length > 0
        ? mapState.selectedSeats.map((x) => x?.id)
        : []
    );
    const isDisable =
      formStyle === "flexible"
        ? mapState.routePath?.length <= 1
        : mapState.selectedSeats?.length <= 0 || mapState.isolatedSeat;

    toggleSubmit(isDisable);
  }, [
    mapState.sectionAvailableSeats,
    mapState.selectedSeats,
    mapState.isolatedSeat,
    mapState.routePath,
  ]);
  // console.log("props", mapState.maxSeatsSelected);
  return (
    <div className={classes.map}>
      <div className={classes.map__screen}>
        <div
          className={cx(
            classes.map__screen__container,
            formStyle === "flexible" && openSection
              ? classes.map__screen__container__disabled
              : ""
          )}
          ref={mapContainerRef}
        />
        <div className={classes.map__screen__zoom}>
          <div className={classes.map__screen__navigation__btn} ref={zoomInRef}>
            <span>+</span>
          </div>
          <div
            className={classes.map__screen__navigation__btn}
            ref={zoomOutRef}
          >
            <span style={{ top: -11, left: 1 }}>_</span>
          </div>
        </div>

        <div className={classes.map__screen__navigation}>
          {mapState.routePath.length > 1 && (
            <>
              <div
                className={classes.map__screen__navigation__btn}
                onClick={goBackHandler}
              >
                <ReactSVG
                  src={ArrowLeft}
                  beforeInjection={(svg) => {
                    svg.setAttribute(
                      "style",
                      `width: 19px;
              margin-top: 3px;`
                    );
                  }}
                />
              </div>
              <div
                className={classes.map__screen__navigation__btn}
                onClick={goHomeHandler}
              >
                <ReactSVG
                  src={StartOver}
                  beforeInjection={(svg) => {
                    svg.setAttribute(
                      "style",
                      `width: 22px;
                margin-top: 3px;`
                    );
                  }}
                />
              </div>
            </>
          )}

          {mapState.loading && (
            <div
              className={cx(
                classes.map__screen__navigation__isolated,
                classes.loaderMap
              )}
            >
              <div className={classes.spinner}>
                <Spinner />
              </div>
              <p>Loading seats ...</p>
            </div>
          )}
          {mapState.isolatedSeat && (
            <div className={classes.map__screen__navigation__isolated}>
              <p>Selection cannot leave behind 1 stranded seat</p>
            </div>
          )}
          {mapState.maxSeatsSelected && !mapState.isolatedSeat && (
            <div className={classes.map__screen__navigation__isolated}>
              <p>
                Maximum of 6 seats. Click "Chat with Representative" below to
                discuss options.
              </p>
            </div>
          )}
          {mapState.noSeatsAvailable && (
            <div className={classes.map__screen__navigation__isolated}>
              <p>There is no seat available</p>
            </div>
          )}
        </div>
      </div>
      <div className={classes.sidebar}>
        <div className={classes.sidebar__header}>
          <h2 className={classes.planTitle}>{planTitle}</h2>
          {planTitle !== "82-Game Full Season Premier Plan" &&
            formStyle !== "flexible" && (
              <h4 className={classes.planSubTitle}>({planName})</h4>
            )}
        </div>
        <div className={classes.sidebar__content}>
          <div className={classes.availability}>
            <div className={classes.availability__header}>
              <span>Seating Area</span>
              <span>Price per {formStyle === "classic" ? "Seat" : "Plan"}</span>
            </div>
            <div className={classes.availability__list}>
              {loaderShow ? (
                <div
                  className={cx(
                    parentClasses.loader__wrapper,
                    loaderShow ? parentClasses.loader__wrapper__active : ""
                  )}
                >
                  <div className={parentClasses.loader}>
                    <Spinner />
                  </div>
                </div>
              ) : (
                <>
                  {seatsInfo !== "" && typeof seatsInfo !== "undefined" ? (
                    seatsInfo.map((res, index) => (
                      <div
                        key={index}
                        className={cx(
                          classes.availability__item,
                          mapState.hoveredSection === res.name
                            ? classes["availability__item-active"]
                            : ""
                        )}
                        onClick={() => {
                          listSectionClickHandler(res.name);
                        }}
                        onMouseEnter={() => {
                          listSectionHoverHandler(res.name);
                        }}
                        onMouseLeave={() => {
                          listSectionHoverHandler(null);
                        }}
                      >
                        {/* <span
                          className={
                            colours[
                              res.name.toLowerCase().replace(/[/ ]/g, "_")
                            ]
                          }
                        ></span> */}
                        <div className={classes.availability__item__name}>
                          {res.name}
                        </div>
                        <div className={classes.availability__item__price}>
                          $
                          {formStyle === "classic"
                            ? res.price.toLocaleString("en-US")
                            : (res.price * flexMultiply).toLocaleString(
                                "en-US"
                              )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      className={cx(
                        parentClasses.loader__wrapper,
                        loaderShow ? parentClasses.loader__wrapper__active : ""
                      )}
                    >
                      <div className={parentClasses.loader}>
                        <Spinner />
                      </div>
                    </div>
                  )}{" "}
                </>
              )}
            </div>
          </div>
          <div className={classes.sections__details} ref={refOpenSection}>
            <div className={classes.details__header}>
              <h3>
                3D SEAT VIEW:<span> (click arrows to enlarge)</span>
              </h3>
            </div>
            <div
              className={classes.details__map_container}
              ref={viewer3dContainerRef}
            />
            <div className={classes.details__preview}>
              <div className={classes.details__preview__item}>
                <span>section:</span>
                {mapState.routePath.length > 1
                  ? getSectionNameById(
                      mapState.routePath[mapState.routePath.length - 1]
                    ).replace("S_", "")
                  : ""}
              </div>
              <span className={classes.devider}>|</span>
              <div className={classes.details__preview__item}>
                <span>Row:</span>
                {mapState.hoveredSeat.row}
              </div>
              <span className={classes.devider}>|</span>
              <div className={classes.details__preview__item}>
                <span>Seat:</span>
                {mapState.hoveredSeat.seat}
              </div>
            </div>
            <div className={classes.details__seats}>
              {formStyle === "classic" ? (
                <>
                  <h2>Selected seat(s):</h2>
                  {mapState.selectedSeats.map((seat, index) => (
                    <div
                      key={index}
                      className={cx(
                        classes.availability__item,
                        classes.availability__seat_item
                      )}
                    >
                      <div className={classes.availability__item__name}>
                        <div>
                          <span>Section:</span>{" "}
                          {mapState.routePath.length > 1
                            ? getSectionNameById(
                                mapState.routePath[
                                  mapState.routePath.length - 1
                                ]
                              ).replace("S_", "")
                            : ""}
                        </div>
                        <div>
                          <span>Row:</span> {seat?.row}
                        </div>
                        <div>
                          <span>Seat:</span> {seat?.seatNumber}
                        </div>
                      </div>
                      <div
                        className={classes.availability__item__price}
                        onClick={() => {
                          deleteSelectedSeat(seat);
                        }}
                      >
                        &times;
                      </div>
                    </div>
                  ))}
                  {!mapState.selectedSeats ||
                  mapState.selectedSeats?.length === 0 ? (
                    <p className={classes.no_seat_selected}>
                      No seats selected
                    </p>
                  ) : (
                    <p className={classes.checkout_text}>
                      Please tap the red arrow at the bottom of the page to
                      check out.
                    </p>
                  )}
                </>
              ) : (
                <>
                  <div
                    className={classes.selectButton}
                    onClick={() => history.push("checkout")}
                  >
                    Select{" "}
                    {mapState.routePath.length > 1
                      ? getSectionNameById(
                          mapState.routePath[mapState.routePath.length - 1]
                        ).replace("S_", "")
                      : ""}
                  </div>
                  <p className={classes.info}>
                    3D Seat View shown represents a sample view from selected
                    Seating Area.
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
        {formStyle === "flexible" && (
            <div className={classes.planDescription}>
              Choose your preferred seating area below. The vouchers for your
              Pick 'Em Plan will be good for this location. As you redeem your
              vouchers on a fluid basis througout the season, you will claim
              your exact seats for each game.
            </div>
          )}
      </div>
    </div>
  );
}

export default Map3D;
